import React from "react";
import FaqPage from "./views/FaqPage";

const ProductList = () => {
  return (
      <FaqPage />
  );
};

export default ProductList;
